import React from "react";
import styles from "./ProductsSelectSettingContainer.module.scss";
import cx from "classnames";


interface IProductSelectSettingsContainer {
    heading: string;
    className?: string;
}

export const ProductSelectSettingsContainer: React.FC<IProductSelectSettingsContainer> = (
    props
) => {
    const { heading, children, className } = props;

    return (
        <div
            className={cx("layout-multi-product-container", 
                {[className]: !!className
            })}>
            <h1 className="text-align--center layout-multi-products-header">{heading}</h1>
            {children}
        </div>
    );
};
